export default function BiographySection() {
  return (
    <section className="py-20 bg-white" id="about" aria-labelledby="biography-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/6d588a7c18ffff00d30b97de4504c2f6/75b409520804afa5ccc7cafce844d88f.png"
              alt="Curtis Waters, Founder and CEO of Curtis Waters AI, business portrait"
              title="Curtis Waters - Founder & AI Innovation Expert"
              className="rounded-2xl shadow-xl object-cover w-full h-[500px]"
              loading="lazy"
              width="500"
              height="500"
            />
            
            {/* Achievement Badge */}
            <div className="absolute -bottom-6 -right-6 bg-red-600 text-white rounded-xl p-6 shadow-lg" role="status" aria-label="25 years of experience">
              <div className="text-center">
                <div className="text-2xl font-bold">25</div>
                <div className="text-sm">Years Experience</div>
              </div>
            </div>
          </div>
          
          {/* Right - Biography Content */}
          <article>
            <header className="mb-6">
              <span className="text-red-600 font-semibold text-lg">Charlotte NC AI Expert</span>
              <h2 id="biography-heading" className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">
                Curtis Waters: Deal Evaluator &amp; Business Intelligence Pioneer
              </h2>
            </header>
            
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p className="text-lg">
                With over <strong>25 years of experience</strong> as an <strong>AI consultant</strong> and <strong>deal evaluator</strong> in <strong>Charlotte NC</strong>, Curtis Waters has delivered <strong>AI solutions</strong>, <strong>business intelligence</strong>, and <strong>machine learning</strong> services to more than <strong>100 companies</strong>, driving <strong>business transformation</strong> and <strong>digital innovation</strong> across industries.
              </p>
              
              <p>
                After witnessing countless businesses in <strong>Charlotte NC</strong> struggle with complex, expensive <strong>AI implementation</strong> that promised everything but delivered little, Curtis founded this platform with a simple mission: <strong className="text-gray-900">make powerful <strong>AI business solutions</strong>, <strong>predictive analytics</strong>, and <strong>business automation</strong> accessible, affordable, and immediately actionable for growing businesses seeking <strong>business transformation</strong> and <strong>competitive advantage</strong>.</strong>
              </p>
              
              {/* Quote */}
              <blockquote className="border-l-4 border-red-600 pl-6 italic text-lg text-gray-700 mt-8">
                <p>"As a <strong>deal evaluator</strong> and <strong>AI expert</strong> in <strong>Charlotte NC</strong>, I've seen firsthand how <strong>business intelligence</strong> and <strong>data analytics</strong> transform operations. <strong>AI solutions</strong> shouldn't be a luxury for tech giants. Every growing business deserves access to <strong>business automation AI</strong>, <strong>machine learning</strong>, and <strong>predictive analytics</strong> that actually works. That's why I built this platform – to democratize <strong>AI solutions</strong> and deliver real <strong>business transformation</strong> for <strong>Charlotte NC</strong> companies."</p>
                <footer className="sr-only">- Curtis Waters, Founder & CEO</footer>
              </blockquote>
              
              <div className="flex items-center mt-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/ae37c3e141d58f115f4bc3aa74db953a.jpg"
                  alt="Curtis Waters signature"
                  className="h-12 mr-4"
                  loading="lazy"
                  width="200"
                  height="80"
                />
                <div>
                  <div className="font-semibold text-gray-900">Curtis Waters</div>
                  <div className="text-sm text-gray-600">Founder &amp; CEO</div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}